import { FormHelperText, InputLabel, FormControl as MuiFormControl } from '@mui/material';
import type { FC } from 'react';
import type { FormControlProps } from './FormControl.types';

const FormControl: FC<FormControlProps> = ({
  field,
  children,
  error,
  required,
  isFieldReadOnly,
  errorMessage,
  isFieldOptional,
  renderLabel = false,
  ...rest
}) => (
  <MuiFormControl error={error} {...rest}>
    {renderLabel && (
      <InputLabel
        id={`${field?.code}_label`}
        required={required}
        shrink={isFieldReadOnly ? true : undefined}
      >
        {isFieldOptional ? `${field?.name} (optional)` : field?.name}
      </InputLabel>
    )}

    {children}

    {error && <FormHelperText>{errorMessage}</FormHelperText>}
  </MuiFormControl>
);

export default FormControl;
